import { axiosGateway } from "@/services/axiosTools";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { getGateWayToken } from "../ai_chat";
import Cookie from "js-cookie";
import store from "@/store";
import { DBStorage } from "@/jsBridge";
import { openSurveyDialog, resetSurveyUrl } from '@/utils/nps'
import { authorizeApply, anthorizeApplyBySn } from "@/api/ai";
import { randomString, signature } from "@/utils/index"; 
const config = require('../../../../env/index.js')
// import { aisearchReportData } from "@/utils";
import Vue from "vue"
import AiChatUtil from '@/utils/aiChatUtil.js'
import { cloneDeep } from 'lodash'
let $fetchAskFurther = null

import {
    getMicroAppGetUserIdentityMark,
} from '@/views/GameBox/utils'


const SLBROWSER_PC_AI_ASSIST_AUTHORIZATION =
  "slbrowser_pc_ai_assist_authorization";
const env = process.env.NODE_ENV;
const domain =
  env === "development"
    ? "https://cloud-aigc.mbgtest.lenovomm.com"
    : "https://ai.lenovomm.com";
const interestingDomain =
  env === "development"
    ? "https://cloud-rest.mbgtest.lenovomm.com"
    : "https://cloud-rest.lenovomm.com";

export function showLoginTips(source) {
  console.log("showLoginTips", source);
  store.commit("setShowLoginTips", true);
}

export function callLogin() {
  store.commit("setShowLoginTips", false);
  console.log("AISearch_Entrance_Login");
  aisearchReportData('click', 'AISearch_Entrance_Login', '', [
      {
          key: 'param2',
          value: '',
      },
      {
          key: 'param3',
          value: JSON.stringify({
              pageversion: Vue.prototype.searchVersion,
          }),
      },
  ]);
  if (window.pcmjssdk) {
    window.pcmjssdk?.commonMethod?.lenovoidLogin();
  } else {
    window.SLBSDK.nativeCall("SLLIDLogin");
  }
}

let prevAction = "";
export function aisearchReportData(
  category,
  action,
  label,
  params,
  isBrowser = false
) {
  console.log('.........aisearchReportData', category, action, label, params)
  if (
    prevAction === action &&
    prevAction === "AISearch_Entrance_Login_Success"
  ) {
    prevAction = action;
    return;
  }
  prevAction = action;
  // checkconfig 为 0 代表强制上报
  if (!isBrowser && window.pcmjssdk) {
    // stick
    const data = [
      {
        key: "pcm_version",
        value: window?.pcmjssdk?.commonMethod?.GetVersion(),
      },
    ];
    if (params) {
      data.push(...params);
    }
    const reportdata = {
      category: category,
      action: action,
      label: label,
      data: data,
      checkconfig: 0,
    };
    window.pcmjssdk.commonMethod.reportBigdata(JSON.stringify(reportdata));
  }
  if (isBrowser && !window.pcmjssdk) {
    // 浏览器
    const reportdata = {
      category: category,
      action: action,
      label: label,
      catever: "",
      ...params,
    };
    // console.log("SLDataReport", reportdata);
    window.SLBSDK.nativeCall("SLDataReport", [reportdata]);
  }
}
export function checkLogin(touristCount) {
  // console.log('checkLogin', touristCount);
  if (store.state.loginInfo?.loginid) {
    //已登录
    return true;
  } else {
    if (window.pcmjssdk) {
      let count = parseInt(localStorage.getItem('AI_SEARCH_TOURIST_USED_COUNT')) || 0
      console.log('查询游客发送次数', count)
      if (count >= 5 && touristCount) {
        showLoginTips('checkLogin');
        aisearchReportData('show', 'TouristToast', '', [
          {
            key: 'param2',
            value: JSON.stringify({
              id: 'AIsearch'
            }),
          },
          {
            key: 'param3',
            value: JSON.stringify({
              pageversion: Vue.prototype.searchVersion,
            }),
          },
        ])
        Vue.prototype.$message({
          message: '请登录解锁该限制',
          type: 'warning',
          duration: 1500,
          customClass: 'lg-message--success top',
          offset: 100
        })
        return false
      }
      return true
    }
  }
}

async function getAuthorization(data = {}, abortController) {
  let token = ''
  if (!store.state.loginInfo || !store.state.loginInfo?.loginid) {
    let nativeInfo = window.pcmjssdk ? await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_WRAPPLUGIN_GET_BASIC_SYSTEMINFO') : await window.SLBSDK.nativeCall("SLGetNativeInfo")
    if (nativeInfo) {
      nativeInfo = typeof nativeInfo === "object" ? nativeInfo : JSON.parse(nativeInfo)
      token = window.pcmjssdk ? nativeInfo.sn : nativeInfo.PCSN || nativeInfo.PCSuperSN
    }
    const params = {
      appId: config.APPID,
      nonce: randomString(10),
      sign_type: "RSA2",
      timestamp: Date.now(),
      touristId: token,
      touristType: 'sn'
    }
    const str = Object.keys(params)
      .sort()
      .filter((k) => params[k])
      .map((k) => `${k}=${params[k]}`)
      .join("&");

    params.sign = signature(str);
    return anthorizeApplyBySn(params, abortController)
    .then((res) => {
      if (res.code === 10000 && res.data && res.data.accessToken) {
        const slbrowser_pc_ai_assist_authorization = `${
          res.data.tokenType ? res.data.tokenType : "bearer"
        } ${res.data.accessToken}`;
        const slbrowser_pc_ai_assist_authorization_cookie = `${SLBROWSER_PC_AI_ASSIST_AUTHORIZATION}=${slbrowser_pc_ai_assist_authorization}${
          res.data.expires
            ? ";expires=" + new Date(res.data.expires).toUTCString()
            : ""
        }`;
        document.cookie = slbrowser_pc_ai_assist_authorization_cookie;
        return slbrowser_pc_ai_assist_authorization;
      }
    })
    .catch((err) => {
      console.log("授权申请失败", err);
    });
  } else {
    let loginInfo = {}
    try {
      loginInfo = window.pcmjssdk
        ? await window.pcmjssdk.commonMethod.getLoginInfo()
        : await window.SLBSDK.nativeCall("SLGetLoginStatus");
    } catch (error) {
      console.log(error)
    }
    // 从端获取浏览器信息(UUID)
    // const SLBInfo = await window.SLBSDK.nativeCall('SLGetNativeInfo')
    // const loginInfo = ;
    // const { realm } = SLBInfo;
    loginInfo = typeof loginInfo === "object" ? loginInfo : JSON.parse(loginInfo);
    store.commit("setLoginInfo", loginInfo);
    const { token, realm } = loginInfo;
    data.token = token;
    data.realm = realm;
    return authorizeApply(data, abortController)
    .then((res) => {
      if (res.code === 10000 && res.data && res.data.accessToken) {
        const slbrowser_pc_ai_assist_authorization = `${
          res.data.tokenType ? res.data.tokenType : "bearer"
        } ${res.data.accessToken}`;
        const slbrowser_pc_ai_assist_authorization_cookie = `${SLBROWSER_PC_AI_ASSIST_AUTHORIZATION}=${slbrowser_pc_ai_assist_authorization}${
          res.data.expires
            ? ";expires=" + new Date(res.data.expires).toUTCString()
            : ""
        }`;
        document.cookie = slbrowser_pc_ai_assist_authorization_cookie;
        return slbrowser_pc_ai_assist_authorization;
      }
    })
    .catch((err) => {
      console.log("授权申请失败", err);
    });
  } 
}

async function getToken(isRetry = false) {
  let authorization = "";
  if (!isRetry && Cookie.get("slbrowser_pc_ai_assist_authorization")) {
    authorization = Cookie.get("slbrowser_pc_ai_assist_authorization");
  }
  if (!authorization) {
    authorization = await getAuthorization();
    // if (window.pcmjssdk) {
    //   authorization = await getGateWayToken();
    // } else {
    //   authorization = await getAuthorization();
    // }
  }
  return authorization;
}

function clearCurrentResult() {
  store.commit("clearAnswer");
}

async function retryWithAuthorization(params) {
  const data = await getToken(true);
  if (!data) {
    showLoginTips('retryWithAuthorization');
  } else {
    fetchAISearchResult(params);
  }
}


export function reportAdImpression(url) {
  fetch(url, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText)
      }
      return response.json()
    })
    .then(data => console.log(data))
    .catch(error => console.error('Failed to report ad impression:', error))
}

// import mock from './mock.json'
export async function getAdvertiseNew(params) {
  // store.commit("setAdvertiseNew", mock)
  // return
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v2/adsearch/yuque/1.4`,
      data: params,
      headers: {
        'authorization': Cookie.get("slbrowser_pc_ai_assist_authorization"),
        // 'x-forwarded-for': '10.109.83.127',
        // timeout: 1000 * 120,
        'user-agent': window.navigator.userAgent,
      },
    })
    const { code, data } = res
    if (code === 10000) {
      store.commit("setAdvertiseNew", data)
    }
  } catch (e) {
    console.log(e, "getAdvertiseerror")
  }
}

export async function getAdvertiseV2(params) {
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v2/adsearch/yuque`,
      data: params,
      headers: {
        'authorization': Cookie.get("slbrowser_pc_ai_assist_authorization"),
        // 'x-forwarded-for': '10.109.83.127',
        // timeout: 1000 * 120,
        'user-agent': window.navigator.userAgent,
      },
    })
    const { code, data } = res
    if (code === 10000) {
      store.commit("setAdvertise", data)
    }
  } catch (e) {
    console.log(e, "getAdvertiseerror")
  }
}

// async function getAdvertise(params, searchCode) {
//   // 无网络处理
//   try {
//     const res = await axiosGateway.post({
//       url: `${domain}/ai-browser/rest/v1/adsearch/query`,
//       data: params,
//       headers: {
//         // authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
//         // timeout: 1000 * 120,
//         "user-agent": window.navigator.userAgent,
//       },
//     });
//     const { code, data } = res;
//     console.log(res, "--advertiseres");
//     if (code === 10000) {
//       store.commit("setAdvertise", data);
//     }
//   } catch (e) {
//     if (e.code === "ERR_NETWORK") {
//       store.commit("serCurrentAnswer", { type: "networkError" });
//     }
//     console.log(e, "getAdvertiseerror");
//   }
// }

export function generateRandomString(minLength, maxLength) {
  const charSet = 'abcdefghijklmnopqrstuvwxyz';
  const stringLength = Math.floor(Math.random() * (maxLength - minLength + 1) + minLength);
  let result = '';
  for (let i = 0; i < stringLength; i++) {
    result += charSet[Math.floor(Math.random() * charSet.length)];
  }
  return result;
}

/**
 * 通过imageId获取图片地址
 */
export function getUploadImageUrlByImageId(fileId) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await getToken();
      if (!data) {
        showLoginTips('getUploadImageUrlByImageId');
        return resolve(null);
      }
      fetch(`${domain}/ai-browser/rest/v1/file/query?fileId=${fileId}`, {
        method: 'GET',
        headers: {
          authorization: data,
        }
      })
      .then(async res => {
        if (res.ok) {
          return res.json()
        } else if (res.status === 401) {
          const data = await getToken(true)
          if (!data) {
            showLoginTips('getUploadImageUrlByImageId   then');
            return resolve(null);
          }
          fetch(`${domain}/ai-browser/rest/v1/file/query?fileId=${fileId}`, {
            method: 'POST',
            headers: {
              authorization: data,
            },
            body: formData
          })
          .then(res => res.json())
          .then(res => resolve(res))
          .catch(() => resolve(null))
        }
      })
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        resolve(null)
      })

    } catch(error) {
      resolve(null)
    }
  })
}


/**
 * 上传文件
 */
export function uploadFileToServer(formData) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await getToken();
      if (!data) {
        // showLoginTips('uploadImageToServer');
        return resolve(null);
      }
      fetch(`${domain}/aigc-file-service/rest/v1/file/upload`, {
        method: 'POST',
        headers: {
          authorization: data,
        },
        body: formData
      })
      .then(async res => {
        if (res.ok) {
          return res.json()
        } else if (res.status === 401) {
          const data = await getToken(true)
          if (!data) {
            // showLoginTips('uploadImageToServer   then');
            return resolve(null);
          }
          fetch(`${domain}/aigc-file-service/rest/v1/file/upload`, {
            method: 'POST',
            headers: {
              authorization: data,
            },
            body: formData
          })
          .then(res => res.json())
          .then(res => resolve(res))
          .catch(() => resolve(null))
        }
      })
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        resolve(null)
      })

    } catch(error) {
      resolve(null)
    }
  })

} 
/**
 * 上传图片
 */
export function uploadImageToServer(formData) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await getToken();
      if (!data) {
        showLoginTips('uploadImageToServer');
        return resolve(null);
      }
      fetch(`${domain}/ai-browser/rest/v1/upload/picture`, {
        method: 'POST',
        headers: {
          authorization: data,
        },
        body: formData
      })
      .then(async res => {
        if (res.ok) {
          return res.json()
        } else if (res.status === 401) {
          const data = await getToken(true)
          if (!data) {
            showLoginTips('uploadImageToServer   then');
            return resolve(null);
          }
          fetch(`${domain}/ai-browser/rest/v1/upload/picture`, {
            method: 'POST',
            headers: {
              authorization: data,
            },
            body: formData
          })
          .then(res => res.json())
          .then(res => resolve(res))
          .catch(() => resolve(null))
        }
      })
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        resolve(null)
      })

    } catch(error) {
      resolve(null)
    }
  })

} 


/**
 * 
 * 根据图片获取提示词
 * 
 */
export function getImageAnalysis(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const authorization = await getToken();
      if (!authorization) {
        showLoginTips('getImageAnalysis');
        return resolve(null);
      }

      const abortController = new AbortController();
      const timeoutId = setTimeout(() => {
        abortController.abort(); // Abort the request on timeout
        resolve(null);
        throw new Error('getImageAnalysis timed out');
      }, 10000);

      fetchEventSource(`${domain}/ai-browser/rest/v1/picture/analysis`, {
        method: 'POST',
        signal: abortController.signal,
        headers: {
          authorization: authorization,
          'content-type': 'application/json'
        },
        body: JSON.stringify({...data, promptCode: '1749624120187',}),
        onmessage: res => {
          clearTimeout(timeoutId);
          if (res && res.data) {
            const data = JSON.parse(res.data)
            if (data && data.code === 10000 && data.data && data.data.result) {
              const result = JSON.parse(data.data.result)
              if (result && result.questions) {
                return resolve(result.questions)
              }
              resolve(null)
              throw new Error('getImageAnalysis failed')
            }
            resolve(null)
            throw new Error('getImageAnalysis failed')
          }
          resolve(null)
          throw new Error('getImageAnalysis failed')
        },
        onerror: res => {
          clearTimeout(timeoutId);
          resolve(null)
          throw new Error('getImageAnalysis failed')
        }
      })

    } catch(error) {
      resolve(null)
    }
  })
}

function convertMacAddress(mac, separator) {
  const cleanMac = mac.replace(/[:-]/g, '')
  if (cleanMac.length!== 12) {
      return false
  }
  if (separator === '-') {
      return cleanMac.match(/.{1,2}/g).join('-')
  } else if (separator === ':') {
      return cleanMac.match(/.{1,2}/g).join(':')
  } else if (separator === '') {
      return cleanMac
  } else {
      return false
  }
}

export async function runApp(url) {
  try {
    const res = await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_AISPACEPLUGIN_RUNAPPSCHEMEURL',
      url,
    )
    return res
  } catch (error) {
    console.log(error)
    return false
  }
}
export async function getMacList() {
  try {
    const res = await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_AISPACEPLUGIN_GETMACLIST',
    )
    return res
  } catch (error) {
    console.log(error)
    return false
  }
}
export async function checkAppExist(name) {
  try {
    const res = await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_AISPACEPLUGIN_CHECKAPPEXISTBYUNINSTALLGUID',
      name,
    )
    return JSON.parse(res)
  } catch (error) {
    console.log(error)
    return false
  }
}
async function getAdvertiseInfoNew(params) {
  // 获取广告信息 1.4 版本
  const timestamp = new Date().getTime()
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  let deviceInfo = null
  let macList = ''
  let wxInstallState = {
    install: false,
    version: ''
  }
  let yybInstallState = {}
  try {
    deviceInfo = await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_WRAPPLUGIN_GET_BASIC_SYSTEMINFO',
    )
    deviceInfo = JSON.parse(deviceInfo)
    macList = await getMacList()
    wxInstallState = await checkAppExist('WeChat')
    yybInstallState = await checkAppExist('Androws')
  } catch (error) {
    console.log(error)
  }
  const _macList = macList.split(',').map(_ => convertMacAddress(_, ':')).filter(_ => _).join(',')
  if (_macList?.length > 0) {
    await getAdvertiseNew(
      {
        queryWord: params.query,
        adNum: 3,
        app: {
          bundle: "aistick",
          domain: "cloud-rest.lenovomm.com",
          id: "253x347644",
          name: "AiStick",
          version: store.state.aiStickVersion
        },
        device: {
          bootTime: timestamp,
          deviceType: 3,
          doNotTrack: 0,
          initTime: timestamp,
          mac: _macList,
          make: deviceInfo.brand,
          model: deviceInfo.model,
          osType: 4,
          osVersion: deviceInfo.osName,
          screenHeight: screenHeight,
          screenWidth: screenWidth,
          serialNo: deviceInfo.sn,
          updateTime: '',
          userAgent: window.navigator.userAgent,
        },
        height: 480,
        width: 640,
        pos: 3,
        requestId: generateRandomString(32, 36),
        site: {
          domain: 'cloud-rest.lenovomm.com',
          id: '253x347644',
          name: 'aistick',
          page: '',
          referrer: '',
        },
        wxAppVersion: wxInstallState?.version,
        wxInstallState: wxInstallState?.install ? 1 : 0,
        wxSdkVersion: '',
        yybInstallState: yybInstallState?.install ? 1 : 0,
      },
      params.searchCode,
    )
  }
}
async function getAdvertiseInfoOld(params) {
  // 获取广告信息 1.3 版本
  const timestamp = new Date().getTime()
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  let deviceInfo = null
  if (window.pcmjssdk) {
    deviceInfo = await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_WRAPPLUGIN_GET_BASIC_SYSTEMINFO',
    )
    deviceInfo = JSON.parse(deviceInfo)
  } else {
    // 浏览器
    deviceInfo = await window.SLBSDK.nativeCall('SLGetNativeInfo')
    deviceInfo = Object.assign({
      mac: deviceInfo.PCMac,
      brand: deviceInfo.PCType,
      model: deviceInfo.PCType,
      osName: deviceInfo.PCMVersion,
    }, deviceInfo)
  }
  console.log('deviceInfo', deviceInfo)
  if (deviceInfo.mac && convertMacAddress(deviceInfo.mac, ':')) {
    const _mac = convertMacAddress(deviceInfo.mac, ':')
    await getAdvertiseV2(
      {
        queryWord: params.query,
        adNum: 3,
        app: {
          bundle: "aistick",
          domain: "cloud-rest.lenovomm.com",
          id: "253x347644",
          name: "AiStick",
          version: store.state.aiStickVersion || '2.21'
        },
        device: {
          bootTime: timestamp,
          deviceType: 3,
          doNotTrack: 0,
          initTime: timestamp,
          mac: _mac,
          make: deviceInfo.brand,
          model: deviceInfo.model,
          osType: 4,
          osVersion: deviceInfo.osName,
          screenHeight: screenHeight,
          screenWidth: screenWidth,
          serialNo: deviceInfo.sn,
          updateTime: '',
          userAgent: window.navigator.userAgent,
        },
        height: 480,
        width: 640,
        pos: 1, // 1：头部，2：底部；3：侧边栏，4：插屏，5：全屏，0：其他
        requestId: generateRandomString(32, 36),
        site: {
          domain: 'cloud-rest.lenovomm.com',
          id: '253x347644',
          name: 'aistick',
          page: '',
          referrer: '',
        },
      },
      params.searchCode,
    )
  }
}

async function getYYBGames() {
    store.commit('setYybGames', [])
    let macAddr = ''
    let markResult = {}
    try {
        const nativeInfo = await window.SLBSDK.nativeCall('SLGetNativeInfo')
        macAddr = nativeInfo?.mac_list
        const mark = await getMicroAppGetUserIdentityMark()
        if (mark && JSON.parse(mark)) {
            markResult = JSON.parse(mark)
        }
    } catch (error) {
        console.log(error)
    }
    fetch(
        `https://cloud-pclb.lenovomm.com/cloud-browser-discover/rest/discover/v1/pc-browser/navpage-minigame`,
        // `https://cloud-pclb.lenovomm.com/cloud-browser-discover/rest/discover/v1/aistick/game-pkg`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                limit: 4,
                macAddr: macAddr,
                offset: 0,
                qone32: markResult.qone32,
                qone40: markResult.qone40
            })
        }
    )
        .then(res => res.json())
        .then(res => {
            if (res?.code === 10000 && res.data?.results[0]?.data?.length) {
                const games = res.data.results[0].data
                store.commit('setYybGames', games)
            }
        })
}

export async function fetchAISearchResult(params) {
  console.log('fetchAISearchResult', params, params.reasoningMode, store.state.aisearch.searchModel)
  $fetchAskFurther?.Destory()
  $fetchAskFurther = null
  const _params = cloneDeep(params)
  delete _params.imgTips // 请求时删除图片引导
  if (params.searchCode === '360') {
    // 原 360 如果在历史记录，使用重搜，则请求百度
    params.searchCode = 'baidu'
  }
  clearCurrentResult();
  // console.time("SearchDuring");
  // console.time("firstWordDuring");
  store.commit("setStartTime", Date.now());
  store.commit("setCurrentSearchCode", params.searchCode);
  store.commit("setCurrentSearchParams", params);
  store.commit("setAnswerLoading", true);
  store.commit("setGenerationStep", 0);
  if (params.imageId) {
    store.commit('setSearchResultImageUrl', store.state.aisearch.aiSearchImageUploadUrl)
  } else {
    store.commit('setSearchResultImageUrl', '')
  }
  const data = await getToken();
  if (!data) {
    store.commit("serCurrentAnswer", { type: "tokenError" });
    // showLoginTips('fetchAISearchResult');
    return;
  }
  // await getAdvertise(
  //   {
  //     query: params.query,
  //     adnum: "L:1,R:1,B:1",
  //     guid: store.state.loginInfo?.loginid,
  //   },
  //   params.searchCode
  // );

  const isBrowser = !store.state.isAIStick && !window.pcmjssdk
  console.log('isBrowser', store.state.aiStickVersion, isBrowser)
  if (store.state.aiStickVersion < '2.4' || isBrowser) {
    // 浏览器及 2.4 以下版如意显示 1.3 版本广告
    getAdvertiseInfoOld(_params)
  } else {
    getAdvertiseInfoNew(_params)
  }

  if (isBrowser) {
    // PC 接应用宝小游戏
    getYYBGames()
  }

  const abortCol = new AbortController();
  store.commit("setAbortCol", abortCol);
  // const data = await getGateWayToken();
  // console.log(data);
  let haveResult = false;
  let hasReported = false;
  fetchEventSource(`${domain}/ai-browser/rest/v1/${_params.imageId ? 'picture/search' : 'search'}`, {
    method: "POST",
    body: JSON.stringify(_params),
    signal: abortCol.signal,
    openWhenHidden: true,
    headers: {
      "Content-Type": "application/json",
      "Transfer-Encoding": "chunked",
      Authorization: data,
    },
    onopen: (res) => {
      hasReported = false;
      console.log("open", res);
      setTimeout(() => {
        console.log("timeout.....");
        if (!haveResult) {
          store.commit("serCurrentAnswer", { type: "timeoutError" });
        }
      }, 60000);
      if (res.status === 401) {
        //认证失败，触发登录
        // window.pcmjssdk?.onLoginStatusChange((data) => {
        //   console.log(data);
        // });
        retryWithAuthorization(_params);
      }
      // 以下status实际被处理为正常文本返回。
      if (res.status === 10001) {
        // 敏感领域
        aisearchReportData('click', 'AISearch_Result_Error_page', '', [
            {
                key: 'param2',
                value: JSON.stringify({
                    engine: params.searchCode,
                    type: 1,
                }),
            },
            {
                key: 'param3',
                value: JSON.stringify({
                    pageversion: Vue.prototype.searchVersion,
                }),
            },
        ]);
        if (!window.pcmjssdk) {
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Error_page",
            "show",
            {
              params3: JSON.stringify({
                errtype: '敏感领域',
                word: params && params.query,
                engine: params && params.searchCode
              }),
            },
            true
          )
        }
        
      }
      if (res.status === 10002) {
        aisearchReportData('click', 'AISearch_Result_Error_page', '', [
            {
                key: 'param2',
                value: JSON.stringify({
                    engine: params.searchCode,
                    type: 1,
                }),
            },
            {
                key: 'param3',
                value: JSON.stringify({
                    pageversion: Vue.prototype.searchVersion,
                }),
            },
        ]);
        if (!window.pcmjssdk) {
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Error_page",
            "show",
            {
              params3: JSON.stringify({
                errtype: '无权限',
                word: params && params.query,
                engine: params && params.searchCode
              }),
            },
            true
          )
        }
        // 无权限
      }
      if (res.status === 10003) {
        aisearchReportData('click', 'AISearch_Result_Error_page', '', [
            {
                key: 'param2',
                value: JSON.stringify({
                    engine: params.searchCode,
                    type: 1,
                }),
            },
            {
                key: 'param3',
                value: JSON.stringify({
                    pageversion: Vue.prototype.searchVersion,
                }),
            },
        ]);
        if (!window.pcmjssdk) {
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Error_page",
            "show",
            {
              params3: JSON.stringify({
                errtype: '无搜索内容',
                word: params && params.query,
                engine: params && params.searchCode
              }),
            },
            true
          )
        }
        // 无搜索结果
      }
    },
    onmessage: (event) => {
      haveResult = true;
      if (!hasReported) {
        // 第一次返回数据时，如果是游客模式，游客模式次数+1
        if (!store.state.loginInfo || !store.state.loginInfo?.loginid) {
          let count = parseInt(localStorage.getItem('AI_SEARCH_TOURIST_USED_COUNT')) || 0 
          count++
          localStorage.setItem('AI_SEARCH_TOURIST_USED_COUNT', count)
        }
        // AI搜索结果页-发起搜索成功
        aisearchReportData(
          "SLB_NewTabPage",
          "AISearch_Entrance_Search_Enter_Success",
          "click",
          {
            param3: JSON.stringify({
              engine: params.searchCode,
              word: params.query,
            }),
          },
          true
        );

        aisearchReportData(
            'report',
            'AISearch_Entrance_Search_Enter_Success',
            '',
            [
                {
                    key: 'param2',
                    value: JSON.stringify({
                        url: params.imageId && params.imageId[0] ? params.imageId[0] : '',
                        engine: params.searchCode,
                        mode: params.searchMode == 2 ? 'Indepth' : 'Standard',
                        custype: store.state.loginInfo?.loginid ? 0 : 1, // 1（游客模式）/0（非游客模式）
                        type: store.state.aisearch.searchEnterType,
                        word: params.query
                    })
                },
                {
                    key: 'param3',
                    value: JSON.stringify({
                        pageversion: Vue.prototype.searchVersion
                    })
                }
            ]
        )
        store.commit('setSearchEnterType', '')

        hasReported = true;
      }
      // console.log(JSON.parse(event.data), 'event.data')
      resolveEventData(JSON.parse(event.data), abortCol);
    },
    onerror: (e) => {
      resetSurveyUrl() // 不再弹出满意度调研
      if (!hasReported) {
        // AI搜索结果页-发起搜索成功
        aisearchReportData(
          "SLB_NewTabPage",
          "AISearch_Entrance_Search_Enter_Success",
          "click",
          {
            param3: JSON.stringify({
              engine: params.searchCode,
              word: params.query,
            }),
          },
          true
        );

        aisearchReportData(
            'report',
            'AISearch_Entrance_Search_Enter_Success',
            '',
            [
                {
                    key: 'param2',
                    value: JSON.stringify({
                        url: params.imageId && params.imageId[0] ? params.imageId[0] : '',
                        engine: params.searchCode,
                        mode: params.searchMode == 2 ? 'Indepth' : 'Standard',
                        custype: store.state.loginInfo?.loginid ? 0 : 1, // 1（游客模式）/0（非游客模式）
                        type: store.state.aisearch.searchEnterType,
                        word: params.query
                    })
                },
                {
                    key: 'param3',
                    value: JSON.stringify({
                        pageversion: Vue.prototype.searchVersion
                    })
                }
            ]
        )
        store.commit('setSearchEnterType', '')

        hasReported = true;
      }
      store.commit("serCurrentAnswer", { type: "networkError" });
      console.log(e, "errorfetchevent-onerror");
      throw new Error("errorfetchevent-onerror");
    },
  });
}

function resolveEventData(data, abortCol) {
  // console.log(data.data, "data.data");
  if (data.code === 10000) {
    store.commit("serCurrentAnswer", data.data);
    if (
      (store.state.aisearch.sessionId && data.data.traceId) ||
      (data.data.sessionId && store.state.aisearch.traceId)
    ) {
      const params = {
        sessionId: store.state.aisearch.sessionId,
        traceId: store.state.aisearch.traceId || data.data.traceId,
        searchCode: store.state.aisearch.currentSearchCode,
      };
      (store.state.aisearch.currentSearchCode === "metaso" || store.state.aisearch.currentSearchCode === "baidu") &&
        getMindMapping(params, abortCol);
      // store.state.aisearch.currentSearchCode === "360" &&
      //   getRelatedQuestion(params, abortCol);
      (store.state.aisearch.currentSearchCode === "metaso" || store.state.aisearch.currentSearchCode === "baidu") &&
        getRelatedQuestionV2(params, abortCol);
      // getExtendedreading(params, abortCol);
    }
    if (data.data.end === true) {
      const params = {
        sessionId: store.state.aisearch.sessionId,
        traceId: store.state.aisearch.traceId || data.data.traceId,
        searchCode: store.state.aisearch.currentSearchCode,
      };
      getAskFurther(params, abortCol);

      // AI搜索：完整完成一次搜索时弹出
      // 边界场景：报错时不弹调研弹窗
      openSurveyDialog('AI 搜索') // 满意度调研
    }
  }
}

export async function getMindMapping(params, abortCol) {
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v1/mindmapping`,
      data: params,
      headers: {
        authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
        timeout: 1000 * 120,
      },
      signal: abortCol.signal,
    });
    console.log(res, "datatest-----mindmap");
    const { code, data } = res;
    if (code === 10000) {
      store.commit("setMarkMindStr", data);
    }
    store.commit("setReadyBlock");
  } catch (error) {
    store.commit("setReadyBlock");
  }
}

export async function getRelatedQuestion(params, abortCol) {
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v1/relatedinfo`,
      data: params,
      headers: {
        authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
      },
      signal: abortCol.signal,
    });

    const { code, data } = res;
    if (code === 10000) {
      store.commit("setRelatedInfo", data);
    }
    store.commit("setReadyBlock");
  } catch (error) {
    store.commit("setReadyBlock");
  }
}

export async function getRelatedQuestionV2(params, abortCol) {
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v1/relatedobject`,
      data: params,
      headers: {
        authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
      },
      signal: abortCol.signal,
    });
    const { code, data } = res;
    if (code === 10000) {
      store.commit("setRelatedInfo", data);
    }
    store.commit("setReadyBlock");
  } catch (error) {
    store.commit("setReadyBlock");
  }
}

export async function getExtendedreading(params, abortCol) {
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v1/extendedreading`,
      data: params,
      headers: {
        authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
      },
      signal: abortCol.signal,
      timeout: 1000 * 120,
      aisearch: true,
    });
    const { code, data } = res;
    if (code === 10000) {
      store.commit("setExtendedReading", data);
    }
    store.commit("setReadyBlock");
  } catch (error) {
    store.commit("setReadyBlock");
  }
}

export async function getInterestingTags() {
  return axiosGateway.get({
    url: `${interestingDomain}/cloud-browser-aigc-auth/rest/questionlibrary/v1/ai-stick_ai-search/distribute`,
    headers: {
      // authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
      timeout: 1000 * 120,
    },
  });
}

// eslint-disable-next-line no-unused-vars
export async function getAskFurther(params, abortCol) {
  const keyword = store.state.aisearch.currentSearchParams?.query
  const answer = store.state.aisearch.result?.answer
  $fetchAskFurther?.Destory()
  $fetchAskFurther = null
  const prompt = `
        任务描述：
        您的任务是基于用户的原始搜索词及其搜索结果，生成三条与之高度相关的搜索词。这些相关搜索词应该能够进一步帮助用户深化其查询，或者探索与原始搜索词相关的其他话题。
        输入：
        1.	用户的原始搜索词：【${keyword}】
        2.	搜索结果：【${answer}】
        输出：
        基于上述输入，生成三条与用户的原始搜索词高度相关的搜索词，每条搜索词应简洁明了，并尽量体现搜索结果中的关键信息或潜在兴趣点。
        注意事项：
        •	确保生成的相关搜索词与用户的原始搜索词和搜索结果紧密相关。
        •	避免生成过于宽泛或偏离主题的搜索词。
        •	尽量使生成的搜索词具有实际搜索价值，能够引导用户进一步探索相关话题。
  `
  $fetchAskFurther = new AiChatUtil({
    message: prompt,
    requestFinish: (val) => {
      const result = val?.data?.result
      store.commit("serCurrentAnswer", { word: result, type: "askfurther" })
    },
    requestError: () => {
      store.commit("serCurrentAnswer", { word: '', type: "askfurther" })
    },
  })
  /**
  try {
    const res = await axiosGateway.post({
      url: `${domain}/ai-browser/rest/v1/askFurther`,
      data: params,
      headers: {
        authorization: Cookie.get("slbrowser_pc_ai_assist_authorization"),
      },
      signal: abortCol.signal,
    });
    // console.log(res, "datatest-----getExtendedreading");
    const { code, data } = res;
    if (code === 10000) {
      store.commit("serCurrentAnswer", { word: data, type: "askfurther" });
    }
  } catch (error) {
    console.log(error)
  }
  */
}

/**搜索记录
 *
 * @param {*} prompt
 * @param {*} request
 * @param {*} sessionId
 * @param {*} lid
 */
export async function setHistroyList(prompt, request, sessionId, lid) {
  console.log('setHistroyList', prompt, request, sessionId, lid)
  if (!lid) {
    return;
  }
  try {
      let dbObj = new DBStorage("AI_SEARCH", "lid_" + lid)
      const aiSearchList = await dbObj.getItem('ai_search_list')
      const list = aiSearchList ? JSON.parse(aiSearchList) : []
      console.log('.........历史数据', list)
      const currentData = await dbObj.getItem(sessionId)
      const _currentData = currentData ? JSON.parse(currentData) : {}
      console.log('..........currentData', _currentData)
      if (_currentData && _currentData.sessionId === sessionId) {
        console.log('.........已有数据')
        const res = await dbObj.setItem(sessionId, JSON.stringify({ ...prompt, ...request, sessionId }))
        console.log('......存储单条旧数据', res, request)
        const index = list.findIndex(item => item.sessionId === sessionId)
        const _request = cloneDeep(request)
        console.log('........._request 1', _request)
        // 删除值较长的字段
        if (_request) {
          delete _request.advertise
          delete _request.advertiseNew
          delete _request.result
          delete _request.relatedInfo
          delete _request.referenceData
          delete _request.MarkMindStr
        }
        list.splice(index, 1, { ...prompt, ..._request, sessionId })
      } else {
        const reqData = {
          ...prompt,
          ...request,
          sessionId
        }
        console.log('..........新数据', reqData)
        const res = await dbObj.setItem(sessionId, JSON.stringify(reqData))
        console.log('......存储单条新数据', res)
        const _request = cloneDeep(request)
        console.log('........._request', _request)
        // 删除值较长的字段
        if (_request) {
          delete _request.advertise
          delete _request.advertiseNew
          delete _request.result
          delete _request.relatedInfo
          delete _request.referenceData
          delete _request.MarkMindStr
        }
        list.unshift({ ...prompt, ..._request, sessionId })
      }
      console.log('......历史数据', list)
      if (list.length > 100) {
        const _last = list.pop()
        // 删除最后一条
        console.log('........删除最后一条', _last)
        const delRes = await dbObj.removeItem(_last.sessionId)
        console.log('........删除结果', delRes)
      }
      store.commit("setSearchHistoryList", list)
      await dbObj.setItem("ai_search_list", JSON.stringify(list))
  } catch (error) {
    console.log(error)
  }

  /**
  try {
    let historyList = [];
    const historyStr = await dbObj.getItem("ai_search_list");
    if (historyStr) {
      try {
        historyList = JSON.parse(historyStr);
      } catch (error) {
        console.log(error);
      }
    }
    let findIndex = historyList.findIndex(
      (item) => item.sessionId === sessionId
    );
    if (findIndex > -1) {
      // for (let i = 0; i < historyList.length; i++) {
      //   if (historyList[i].sessionId === sessionId) {
      //     historyList[i] = { ...prompt, ...request, sessionId }
      //   }
      // }
      historyList[findIndex] = { ...prompt, ...request, sessionId };
    } else {
      historyList.unshift({ ...prompt, ...request, sessionId });
    }
    if (historyList.length > 100) {
      historyList.pop();
    }
    store.commit("setSearchHistoryList", historyList);
    await dbObj.setItem("ai_search_list", JSON.stringify(historyList));
    // console.log(historyList, await dbObj.getItem('ai_search_list'))
  } catch (err) {
    // 错误码为1的时候，代表获取不到列表，需要初始化列表（set）
    console.log(err);
  }
    */
}

// 搜索词
export async function setSearchHistory(question, sessionId, lid) {
  if (!lid) {
    return;
  }
  let dbObj = new DBStorage("AI_SEARCH", "lid_" + lid);
  let historyList = [];
  try {
    let historyStr = await dbObj.getItem("searchHistoryList");
    if (historyStr) {
      try {
        historyList = JSON.parse(historyStr);
      } catch (error) {
        console.log(error);
        historyList = [];
      }
    }
    const repeatHistoryIndex = historyList.findIndex((item) => {
      return item.question == question;
    });
    if (repeatHistoryIndex > -1) {
      const changeHistory = historyList.splice(repeatHistoryIndex, 1);
      historyList.unshift(changeHistory[0]);
    } else {
      historyList.unshift({ question, sessionId });
    }
    if (historyList.length > 100) {
      historyList.pop();
    }
    store.commit("setSearchWordsHistory", historyList);
    dbObj.setItem("searchHistoryList", JSON.stringify(historyList));
  } catch (error) {
    console.log(error);
  }
}
// 初始化搜索历史记录
export async function initHistory(id) {
  if (!id) {
    return;
  }
  let historyDBObj = new DBStorage("AI_SEARCH", "lid_" + id);
  try {
    let historyList = [];
    let historys = await historyDBObj.getItem("ai_search_list");
    if (historys) {
      historyList = JSON.parse(historys);
    }else{
      historyDBObj.setItem('ai_search_list',JSON.stringify([]))
    }
    store.commit("setSearchHistoryList", historyList);
  } catch (error) {
    console.log(error);
  }
}
